import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { IDashboardGroup, TCreateDashboardGroupDTO } from '@/pages/Dashboards/dashboards.types.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import DashboardGroupDropdown from '@/pages/Dashboards/components/DashboardGroupDropdown'

interface IProps {
  initialParentId?: IDashboardGroup['id']
  open: boolean
  onClose: () => void
}

const CreateDashboardGroupModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [group, setGroup, handleChange] = useStateWithChange<TCreateDashboardGroupDTO>({
    name: '',
    parentId: props.initialParentId ?? null,
  })

  useEffect(() => {
    setGroup({
      name: '',
      parentId: props.initialParentId ?? null,
    })
  }, [props.initialParentId])

  const handleSave = () => {
    wait(dashboardsApi.createGroup(group), (resp) => {
      if (resp.status === 'success') {
        dashboardsEvents.groupCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Создание группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <DashboardGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={group.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={group.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default CreateDashboardGroupModal
